import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { getAllFeatureFlagsForBusinessId } from 'api/admin/businesses/businesses';
import { ApiError } from 'types/api';

type UseGetFeatureFlagsForBusinessResponse = Array<{
  description: string;
  key: string;
  name: string;
  state: boolean;
  temporary: boolean;
}>;

export const useGetFeatureFlagsForBusiness = ({ businessId }: { businessId: number }) => {
  return useQuery<unknown, ApiError, UseGetFeatureFlagsForBusinessResponse>({
    queryKey: ['getFeatureFlagsForBusiness', { businessId }],
    queryFn: async () => {
      const { data } = await getAllFeatureFlagsForBusinessId(businessId);
      return data.flags;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ??
          'An error occurred while fetching feature flags for the business',
        { duration: 4000 },
      );
      return error;
    },
    initialData: [],
    enabled: !!businessId,
  });
};
